class Pubsub {
    
    on(eventName, fn) {
        pubsub[eventName] = pubsub[eventName] || [];
        pubsub[eventName].push(fn);
    }
    
    off(eventName, fn) {
        if(pubsub[eventName]) {
            for(var i = 0; i < pubsub[eventName].length; i++) {
                if(pubsub[eventName][i] === fn) {
                    pubsub[eventName].splice(i, 1);
                    break;
                }
            }
        }
    }
    
    trigger(eventName, data) {
        if(pubsub[eventName]) {
            pubsub[eventName].forEach(function(fn) {
                fn(data);
            });
        }
    }
    
}

window.pubsub = new Pubsub();
